import React from 'react';
import Text from 'Components/Text';
import moment from 'moment';
import { Input } from 'Components/Input';

export default ({
  submissionDate,
  approvalDate,
  name,
  formulaBaseOilNumber,
  formulaEngineType,
  description,
  inputErrors,
  handleInputChange,
}) => {
  return (
    <section className='scene_section'>
      <header>General Info</header>
      <Text
        mainWrapperClassName='text__wrapper_primary _margin_right_30'
        textClassName='text__text_primary'
        label='Submission Date'
        value={submissionDate && moment(submissionDate).format('MM / DD / YYYY')}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Approval Date'
        value={approvalDate && moment(approvalDate).format('MM / DD / YYYY')}
      />
      <Input
        mainWrapperClassName='input__main-wrapper_primary _width_pc_100'
        inputClassName='input__input-field_primary'
        label='Brand name'
        maxLength={250}
        value={name}
        error={inputErrors.description}
        onChange={handleInputChange('name')}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary _margin_right_30'
        textClassName='text__text_primary'
        label='Based on Base Oil Number'
        value={formulaBaseOilNumber}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Engine Type'
        value={formulaEngineType}
      />
      <Input
        mainWrapperClassName='input__main-wrapper_primary _width_pc_100'
        inputClassName='input__input-field_primary'
        label='Description'
        maxLength={250}
        value={description}
        error={inputErrors.description}
        onChange={handleInputChange('description')}
      />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/brand/Application/Edit/GeneralInformation.jsx